<div class="user-settings-warning" [style.background]="backgroundColor$ | async">
  <div class="user-settings-warning-icon-container">
    <app-pencil-icon
      class="user-settings-warning-icon"
      [name]="iconName$ | async"
      [type]="IconTypes.svgIcon"
      [wrapperStyle]="{
        '--pencil-svg-icon-filter': (iconFilter$ | async) ?? ''
      }"
    ></app-pencil-icon>
  </div>

  <div class="user-settings-warning-content">
    <span class="user-settings-warning-content-title">{{ title }}</span>
    <span class="user-settings-warning-content-description">{{ description }}</span>
  </div>
</div>
